// extracted by mini-css-extract-plugin
export default {"wrapper":"LoaderWithoutText_wrapper__sSgu5"};